var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoreHorizontal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "moreHorizontal_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.77 10.21c.98 0 1.77.79 1.77 1.77s-.79 1.77-1.77 1.77S4 12.96 4 11.98s.79-1.77 1.77-1.77m8 1.77c0-.98-.79-1.77-1.77-1.77s-1.77.79-1.77 1.77.79 1.77 1.77 1.77 1.77-.79 1.77-1.77m6.23 0c0-.98-.79-1.77-1.77-1.77s-1.77.79-1.77 1.77.79 1.77 1.77 1.77S20 12.96 20 11.98",
  clipRule: "evenodd"
})));
export default SvgMoreHorizontal;